import { render, staticRenderFns } from "./EnviadasSolicitacoesServicos.vue?vue&type=template&id=2cff278f"
import script from "./EnviadasSolicitacoesServicos.vue?vue&type=script&lang=js"
export * from "./EnviadasSolicitacoesServicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports